var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 193,
    viewBox: "0 0 148 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0934 0.469525C-2.4071 -2.66682 -8.04106 124.113 9.07003 157.257C26.1811 190.402 50.4905 199.596 103.697 186.422C156.903 173.247 156.981 151.796 129.875 103.726C102.768 55.657 138.594 3.60589 68.0934 0.469525Z",
    fill: "#EBF3FF",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueVector);
export default __webpack_public_path__ + "static/media/blue-vector.6ee6f6cf.svg";
export { ForwardRef as ReactComponent };